module.exports = "/images/close.svg?32cf37f7cfbcf11b178fac1cf14e17a1";